/* @ngInject */
const trainButtons = (
  icons,
  trainGo,
  trainAsk
) => {
  const self = {}

  self.search = {
    icon: icons.search,
    action: trainGo.consult,
    display: (_nature) => {
      if (_nature === 'tables') {
        return true
      }
      return false
    },
  }
  self.edit = {
    icon: icons.edit,
    action: trainGo.edit,
    display: (_nature) => {
      return true
    },
  }

  self.addWagon = {
    icon: icons.train.train,
    action: trainGo.addWagon,
    display: (_nature) => {
      if (_nature === 'action') {
        return true
      }
      return false
    },
  }

  self.removeWagon = {
    icon: icons.train.train,
    action: trainGo.removeWagon,
    display: (_nature) => {
      if (_nature === 'action') {
        return true
      }
      return false
    },
    class: (_item) => {
      return 'retour'
    },
  }

  self.delete = {
    icon: icons.delete,
    action: trainAsk.delete,
    display: (_nature) => {
      if (_nature === 'action') {
        return true
      }
      return false
    },
    class: (_item) => {
      return 'retour'
    },
  }

  return self
}
export default trainButtons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/train/resources/buttons.resource.js